import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Subscription, of, pipe } from 'rxjs';
import { map, concatMap, switchMap, filter, finalize } from 'rxjs/operators';
import { Department } from 'src/app/shared/department';
import { ClientApiService } from 'src/app/services/client-api.service';

@Component({
  selector: 'app-show-department-name',
  templateUrl: './show-department-name.component.html',
  styleUrl: './show-department-name.component.css'
})
export class ShowDepartmentNameComponent implements OnInit, OnChanges, OnDestroy {

  departmentName: string = null;
  _departmentslistMC: Department[];
  _departmentMC: Department;
  _loading: boolean;

  private _depListQuery: Subscription;
  private _depChildQuery: Subscription;

  selectedDepartment: string;
  totalRecordsMC: number;

  @Input()
  get parentCompany(): number { return this._parentCompany; }
  set parentCompany(id: number) {
    this._parentCompany = id;
  }
  private _parentCompany: number = null;

  @Input() selectedID: number = null;

  @Input() masterID: number;

  @Output() public selectedDepartmentID: EventEmitter<number> = new EventEmitter();

  constructor(
    private cliApi: ClientApiService,
  ) { }

  private _selectDepartment(): void {

    this._departmentMC = (this.selectedID && this._departmentslistMC) ? this._departmentslistMC.find(x => x.CLIID == this.selectedID) : null;
    this.departmentName = (this._departmentMC) ? this._departmentMC.CLIENTSNIKNAME : null;
  }

  private _reloadComponentData(): void {
    this._depListQuery =
      of(this.parentCompany).pipe(

        filter(c => (c ? true : false)),
        switchMap(id => this.cliApi.getDepartments(id).pipe(

          filter(dep => dep.length > 0),

          map(dep => {
            this._departmentslistMC = dep;
            this._selectDepartment();
          }))))

        .subscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** ShowDepartmentNameComponent ngOnChanges');
    for (let propName in changes) {
      let change = changes[propName];
      // console.log('*** ShowDepartmentNameComponent ngOnChanges (actual): ' + propName + ' ' + JSON.stringify(change.currentValue));
      //console.log('*** PersonselectorComponent ngOnChanges (was):    ' + propName + ' ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'parentCompany':
          this._reloadComponentData();
          break;

        case 'selectedID':
          this._selectDepartment();
          break;
      }
    }
  }

  ngOnDestroy(): void {
    if (this._depListQuery) { this._depListQuery.unsubscribe(); }
    if (this._depChildQuery) { this._depChildQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    this._reloadComponentData();
  }
}
